import type { ReactNode } from "react";
import { cx } from "./cx";
import s from "./avatar.module.css";

const TONES = 6;

/** Same input, same colour, on every device: a plain string hash. */
export function avatarTone(id: string): number {
  let h = 7;
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return h % TONES;
}

export function initials(name: string): string {
  return name.split(/\s+/).filter(Boolean).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
}

export interface AvatarProps {
  /** Stable id or name that picks the colour. */
  id: string;
  name: string;
  size?: "md" | "sm" | "xs";
  className?: string;
}

export function Avatar({ id, name, size = "md", className }: AvatarProps) {
  const tone = avatarTone(id);
  return (
    <span className={cx(s.av, s[size], s[`t${tone}`], className)} data-tone={tone} aria-hidden="true">
      {initials(name)}
    </span>
  );
}

export function AvatarStack({ children }: { children: ReactNode }) {
  return <span className={s.stack}>{children}</span>;
}
